import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const WarningFilledGlyph = /*#__PURE__*/createElement("g", {
  id: "warning_1_"
}, /*#__PURE__*/createElement("path", {
  className: "st10",
  d: "M68.7,63.1C59.8,47.6,51,32.2,42.1,16.8c-0.1-0.1-0.2-0.1-0.3,0C33,32.1,24.1,47.6,15.3,63.1 c-0.1,0.1,0,0.2,0.1,0.2h53.2C68.8,63.3,68.8,63.2,68.7,63.1z M43.7,56.2c-0.5,0.4-1,0.7-1.7,0.7c-0.7,0-1.3-0.2-1.8-0.7 c-0.5-0.4-0.8-1.1-0.8-1.8c0-0.7,0.2-1.3,0.7-1.8c0.5-0.5,1.1-0.7,1.8-0.7c0.7,0,1.3,0.2,1.8,0.7c0.5,0.5,0.7,1.1,0.7,1.8 C44.4,55.2,44.2,55.8,43.7,56.2z M43.7,46.9c0,1.1-0.8,2.1-1.7,2.1c-1,0-1.7-0.9-1.7-2.1l-0.8-14.2c0-1.2,0.8-2.2,2.5-2.2 c1.7,0,2.5,1,2.5,2.2L43.7,46.9z"
}));
const WarningFilled = createSvg({
  name: 'warning_filled',
  path: WarningFilledGlyph
});

export default WarningFilled;
export { WarningFilledGlyph };
